module.exports = __webpack_public_path__ + "static/img/sunday_live_logo.1c3927d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/recruit_2021/program_logo/sunday_live_logo.png
// module id = H7fW
// module chunks = 0